var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 127,
    viewBox: "0 0 91 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.134 3.09994 0 6.92391 0H63L91 29V120C91 123.866 87.9001 127 84.0761 127H6.92391C3.09994 127 0 123.866 0 120V7Z",
    fill: "#4EB072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53L64 25H87L91 29V53Z",
    fill: "#3D915C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0.000244141L91 29.0002H69.7586C66.0259 29.0002 63 25.8662 63 22.0002V0.000244141Z",
    fill: "#FEF8F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 54.5H72",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 68.5H72",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 82.5H72",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 96.5H72",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 55L72.5 95",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 55L45.5 95",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 55L18.5 95",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/Spreadsheet.278744e64523edeccda0a192d229d843.svg";
export { ForwardRef as ReactComponent };